module.exports = __webpack_public_path__ + "media/images/assignment/sync-85866cb6404d430c36a75fad7b472c15.svg";